import { render, staticRenderFns } from "./IconPoweredByStripe.vue?vue&type=template&id=57d4daa6"
import script from "./IconPoweredByStripe.vue?vue&type=script&lang=js"
export * from "./IconPoweredByStripe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports